(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["asd-hero-slideshow"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('asd-hero-slideshow')) {
    class AsdHeroSlideshow extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.initialized = true;
        this.slides = Array.from(this.querySelectorAll('[data-slide]'));
        this.dots = Array.from(this.querySelectorAll('[data-slide-to]'));
        this.previousButton = this.querySelector('[data-previous]');
        this.nextButton = this.querySelector('[data-next]');
        this.status = this.querySelector('[data-status]');
        this.index = Math.max(0, this.slides.findIndex((slide) => slide.classList.contains('is-active')));
        this.loop = this.dataset.loop === 'true';
        this.autoplayEnabled = this.dataset.autoplay === 'true' && this.slides.length > 1;
        this.pauseOnHover = this.dataset.pauseOnHover === 'true';
        this.autoplaySpeed = Number(this.dataset.autoplaySpeed) || 6000;
        this.pauseReasons = new Set();
        this.motionQuery = window.matchMedia('(prefers-reduced-motion: reduce)');

        this.onPrevious = () => this.move(-1, true);
        this.onNext = () => this.move(1, true);
        this.onKeydown = (event) => this.handleKeydown(event);
        this.onPointerEnter = () => this.pause('hover');
        this.onPointerLeave = () => this.resume('hover');
        this.onFocusIn = () => this.pause('focus');
        this.onFocusOut = (event) => {
          if (!this.contains(event.relatedTarget)) this.resume('focus');
        };
        this.onVisibilityChange = () => {
          if (document.hidden) this.pause('visibility');
          else this.resume('visibility');
        };
        this.onMotionChange = () => {
          if (this.motionQuery.matches) this.pause('motion');
          else this.resume('motion');
        };
        this.onBlockSelect = (event) => this.handleBlockSelect(event);
        this.onBlockDeselect = (event) => this.handleBlockDeselect(event);
        this.onDotClick = (event) => {
          const target = Number(event.currentTarget.dataset.slideTo);
          this.goTo(target, true);
        };

        this.previousButton?.addEventListener('click', this.onPrevious);
        this.nextButton?.addEventListener('click', this.onNext);
        this.dots.forEach((dot) => dot.addEventListener('click', this.onDotClick));
        this.addEventListener('keydown', this.onKeydown);
        this.addEventListener('focusin', this.onFocusIn);
        this.addEventListener('focusout', this.onFocusOut);
        document.addEventListener('visibilitychange', this.onVisibilityChange);
        document.addEventListener('shopify:block:select', this.onBlockSelect);
        document.addEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.motionQuery.addEventListener('change', this.onMotionChange);

        if (this.pauseOnHover) {
          this.addEventListener('pointerenter', this.onPointerEnter);
          this.addEventListener('pointerleave', this.onPointerLeave);
        }

        if (this.motionQuery.matches) this.pauseReasons.add('motion');
        this.updateSlides(false);
        this.startAutoplay();
      }

      disconnectedCallback() {
        window.clearTimeout(this.timer);
        this.previousButton?.removeEventListener('click', this.onPrevious);
        this.nextButton?.removeEventListener('click', this.onNext);
        this.dots?.forEach((dot) => dot.removeEventListener('click', this.onDotClick));
        this.removeEventListener('keydown', this.onKeydown);
        this.removeEventListener('focusin', this.onFocusIn);
        this.removeEventListener('focusout', this.onFocusOut);
        this.removeEventListener('pointerenter', this.onPointerEnter);
        this.removeEventListener('pointerleave', this.onPointerLeave);
        document.removeEventListener('visibilitychange', this.onVisibilityChange);
        document.removeEventListener('shopify:block:select', this.onBlockSelect);
        document.removeEventListener('shopify:block:deselect', this.onBlockDeselect);
        this.motionQuery?.removeEventListener('change', this.onMotionChange);
        this.initialized = false;
      }

      handleKeydown(event) {
        if (event.altKey || event.ctrlKey || event.metaKey) return;
        if (event.target.closest('input, textarea, select')) return;

        if (event.key === 'ArrowLeft') {
          event.preventDefault();
          this.move(-1, true);
        } else if (event.key === 'ArrowRight') {
          event.preventDefault();
          this.move(1, true);
        } else if (event.key === 'Home') {
          event.preventDefault();
          this.goTo(0, true);
        } else if (event.key === 'End') {
          event.preventDefault();
          this.goTo(this.slides.length - 1, true);
        }
      }

      handleBlockSelect(event) {
        if (!(event.target instanceof Element)) return;
        const selectedSlide = event.target.closest('[data-slide]');
        if (!selectedSlide || !this.contains(selectedSlide)) return;

        this.pause('editor');
        this.goTo(Number(selectedSlide.dataset.slideIndex), false);
      }

      handleBlockDeselect(event) {
        if (!(event.target instanceof Element)) return;
        if (this.contains(event.target)) this.resume('editor');
      }

      move(direction, userInitiated) {
        const requestedIndex = this.index + direction;

        if (!this.loop && (requestedIndex < 0 || requestedIndex >= this.slides.length)) return;
        this.goTo(requestedIndex, userInitiated);
      }

      goTo(requestedIndex, userInitiated) {
        if (!this.slides.length) return;

        let nextIndex = requestedIndex;
        if (this.loop) {
          nextIndex = (requestedIndex + this.slides.length) % this.slides.length;
        } else {
          nextIndex = Math.min(Math.max(requestedIndex, 0), this.slides.length - 1);
        }

        this.index = nextIndex;
        this.updateSlides(userInitiated);

        if (userInitiated) this.restartAutoplay();
      }

      updateSlides(announce) {
        this.slides.forEach((slide, slideIndex) => {
          const active = slideIndex === this.index;
          slide.classList.toggle('is-active', active);
          slide.setAttribute('aria-hidden', String(!active));
          slide.toggleAttribute('inert', !active);
        });

        this.dots.forEach((dot, dotIndex) => {
          const active = dotIndex === this.index;
          dot.classList.toggle('is-active', active);
          if (active) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });

        if (!this.loop) {
          if (this.previousButton) this.previousButton.disabled = this.index === 0;
          if (this.nextButton) this.nextButton.disabled = this.index === this.slides.length - 1;
        }

        if (announce && this.status) {
          this.status.textContent = `Slide ${this.index + 1} di ${this.slides.length}`;
        }
      }

      pause(reason) {
        this.pauseReasons.add(reason);
        window.clearTimeout(this.timer);
      }

      resume(reason) {
        this.pauseReasons.delete(reason);
        this.startAutoplay();
      }

      restartAutoplay() {
        window.clearTimeout(this.timer);
        this.startAutoplay();
      }

      startAutoplay() {
        window.clearTimeout(this.timer);

        if (!this.autoplayEnabled || this.pauseReasons.size > 0 || document.hidden) return;
        if (!this.loop && this.index === this.slides.length - 1) return;

        this.timer = window.setTimeout(() => {
          this.move(1, false);
          this.startAutoplay();
        }, this.autoplaySpeed);
      }
    }

    customElements.define('asd-hero-slideshow', AsdHeroSlideshow);
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
